import { SWORN_DATA } from '../gameData';
import { SwornData } from '../types';

export type IconType = keyof SwornData['iconPaths'];

export interface IconPathOptions {
  knight?: string;
  weapon?: string;
  spell?: string;
  faeLord?: string;
  blessingType?: string;
  modifierType?: 'weapon' | 'spell';
  framed?: boolean;
}

export const getIconPath = (
  type: IconType,
  name: string,
  options: IconPathOptions = {}
): string => {
  if (!name) return '';

  let templateKey: IconType = type;
  if (type === 'blessing') {
    if (options.blessingType?.toLowerCase() === 'duo') {
      templateKey = 'duo';
    } else if (options.blessingType?.toLowerCase() === 'shrine') {
      templateKey = 'shrine';
    }
  }

  const pathTemplate = SWORN_DATA.iconPaths[templateKey];

  if (!pathTemplate) {
    console.warn(`No icon path template found for type: ${templateKey}`);
    return '';
  }

  const lowerName = name.toLowerCase().replace(/ /g, '_');

  let finalName = lowerName;
  // Special case for "Static" shrine blessing to avoid potential conflicts
  if (templateKey === 'shrine' && lowerName === 'static') {
    finalName = 'static_shrine';
  }

  let path = pathTemplate.replace(/\$\{name\}/g, finalName);

  // Handle all possible placeholders
  if (options.knight) {
    path = path.replace(/\$\{knight\}/g, options.knight.toLowerCase());
  }
  if (options.weapon) {
    path = path.replace(/\$\{weapon\}/g, options.weapon.toLowerCase());
  }
  if (options.spell) {
    path = path.replace(/\$\{spell\}/g, options.spell.toLowerCase());
  }
  if (options.faeLord) {
    // The JSON data uses ${faelord} (lowercase), so we must match that.
    // We also match ${faeLord} just in case.
    path = path.replace(/\$\{faelord\}/gi, options.faeLord.toLowerCase());
  }
  if (type === 'fae') { // Special case for Fae Lords themselves
    path = path.replace(/\$\{faelord\}/gi, name.toLowerCase());
  }
  if (options.blessingType) {
    path = path.replace(/\$\{blessingType\}/g, options.blessingType.toLowerCase());
  }
  if (options.modifierType) {
    path = path.replace(/\$\{modifierType\}/g, options.modifierType.toLowerCase());
  }
  if (type === 'knight' && options.framed) {
    path = path.replace('icon.png', 'icon_framed.png');
  }

  return path;
};
